/** Document type ID for Lov (hovedlov). */
export const DOCUMENT_TYPE_ID_LOV = 10;

/** Document type ID for Lovbekendtgørelse (LBK). */
export const DOCUMENT_TYPE_ID_LOVBEKENDTGØRELSE = 30;

/** Document type ID for Bekendtgørelse (BEK). */
export const DOCUMENT_TYPE_ID_BEKENDTGØRELSE = 60;

/** Document type ID for Ændringsbekendtgørelse (amendment BEK). */
export const DOCUMENT_TYPE_ID_AENDRINGSBEKENDTGØRELSE = 80;

/** Document type ID for Ikrafttræd. bekendtgørelse. */
export const DOCUMENT_TYPE_ID_IKRAFTTRAEDELSE_BEKENDTGØRELSE = 90;

/** True for ikræfttrædelses-bekendtgørelse (type 90). */
export const isIkrafttraedelseBekendtgoerelseDocumentType = (
  documentTypeId: string | number | undefined | null
): boolean =>
  Number(documentTypeId) === DOCUMENT_TYPE_ID_IKRAFTTRAEDELSE_BEKENDTGØRELSE;

/** True when legislation is Lov or LBK. Accepts string or number documentTypeId. */
export const isLovOrLbk = (
  documentTypeId: string | number | undefined | null
): boolean => {
  if (documentTypeId == null) return false;
  const num = Number(documentTypeId);
  return (
    num === DOCUMENT_TYPE_ID_LOV || num === DOCUMENT_TYPE_ID_LOVBEKENDTGØRELSE
  );
};

/**
 * True for a consolidation window anchor / boundary: Lovbekendtgørelse (30) or
 * Bekendtgørelse (60). Each opens a fresh consolidation window; the next one
 * closes the previous window.
 */
export const isConsolidationAnchorType = (
  documentTypeId: string | number | undefined | null
): boolean => {
  if (documentTypeId == null) return false;
  const num = Number(documentTypeId);
  return (
    num === DOCUMENT_TYPE_ID_LOVBEKENDTGØRELSE ||
    num === DOCUMENT_TYPE_ID_BEKENDTGØRELSE
  );
};

/**
 * True when a document is eligible for a consolidation status/progress badge:
 * Lov (10), Lovbekendtgørelse (30), or Bekendtgørelse (60).
 */
export const isConsolidationEligibleDocumentType = (
  documentTypeId: string | number | undefined | null
): boolean =>
  isLovOrLbk(documentTypeId) ||
  Number(documentTypeId) === DOCUMENT_TYPE_ID_BEKENDTGØRELSE;

/** Display label for Lov/LBK/BEK document types. */
export const lovOrLbkDocumentTypeDisplayName = (
  documentTypeId: string | number | undefined | null
): string | null => {
  if (documentTypeId == null) return null;
  const num = Number(documentTypeId);
  if (num === DOCUMENT_TYPE_ID_LOV) return "Lov";
  if (num === DOCUMENT_TYPE_ID_LOVBEKENDTGØRELSE) return "Lovbekendtgørelse (LBK)";
  if (num === DOCUMENT_TYPE_ID_BEKENDTGØRELSE) return "Bekendtgørelse (BEK)";
  return null;
};
